import { createBrowserRouter } from "react-router-dom";
import ProtectedLayout from "./layouts/ProtectedLayout";
import PublicLayout from "./layouts/PublicLayout";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import NotFoundPage from "./pages/NotFoundPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage"
import HomePage from "./pages/HomePage";
import TermsConditionsPage from "./pages/TermsConditionsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CookiesPage from "./pages/CookiesPage";

const router = createBrowserRouter([
  {
    path: "/dashboard/*",
    element: <ProtectedLayout />,
  },
  {
    // Define routes for public pages
    path: "/",
    element: <PublicLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "register",
        element: <RegisterPage />,
      },
      {
        path: "forgot-password",
        element: <ForgotPasswordPage />,
      },
      {
        path: "login",
        element: <LoginPage />,
      },
      {
        path: "terms-conditions",
        element: <TermsConditionsPage />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "cookies",
        element: <CookiesPage />,
      },
    ],
  },
  {
    // Define route for not found page
    path: "*",
    element: <NotFoundPage />,
  },
]);
export default router;
